import DOMPurify from 'dompurify';
import entitiesToHtml from './entitiesToHtml';

interface IPurifier {
  source: string;
  isHtmlAllowed?: boolean;
}

const purifier = (data: IPurifier) => {
  const { source, isHtmlAllowed = true } = data;

  if (source) {
    const dirty = entitiesToHtml(source.split('data-src').join('src'));

    return DOMPurify.sanitize(dirty, {
      USE_PROFILES: { html: isHtmlAllowed },
    });
  }
};

export const purifierWithoutHtml = source =>
  purifier({ source, isHtmlAllowed: false });

export default purifier;
